import React, { FC } from 'react'
import EditOwnerContainer from 'containers/EditClient/EditOwner'

const EditOwnerPage: FC = () => <EditOwnerContainer />

export default EditOwnerPage
